import { __rest } from "tslib";
import * as React from 'react';
import { memo } from 'react';
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc';
import Upload from './Upload';
import UploadList from './UploadList';
import { ConfigContext } from '../config-provider';
import { removeFileItem } from './utils';
const none = () => void 0;
const itemStyle = {
    width: 104,
    height: 104,
    margin: 4,
    cursor: 'grab',
};
// 预览单个列表
const SortableItem = SortableElement((params) => (React.createElement("div", { style: itemStyle },
    React.createElement(UploadList, Object.assign({ locale: { previewFile: '预览', removeFile: '删除' }, listType: params.props.listType }, params.props, { onPreview: params.onPreview, onRemove: params.onRemove, items: [params.item] })))));
const listStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
};
// 预览列表
const SortableList = SortableContainer((params) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('upload');
    return (React.createElement("div", { style: listStyle },
        params.items.map((item, index) => (React.createElement(SortableItem, { key: `${item.uid || item.name + `-${index}` || index}`, index: index, 
            // @ts-ignore
            item: item, props: params.props, onPreview: params.onPreview, onRemove: params.onRemove }))),
        React.createElement(Upload, Object.assign({}, params.props, { showUploadList: false, onChange: params.onChange, className: `${prefixCls}-picture-card-dragable-wrapper` }), params.props.children)));
});
const DragableList = memo((_a) => {
    var { onChange: onFileChange, onPreview = none, onRemove = none } = _a, props = __rest(_a, ["onChange", "onPreview", "onRemove"]);
    const fileList = props.fileList || [];
    const onSortEnd = ({ oldIndex, newIndex }) => {
        onFileChange &&
            onFileChange({
                file: fileList[oldIndex],
                fileList: arrayMove(fileList, oldIndex, newIndex),
            });
    };
    const handleChange = ({ file: file, fileList: newFileList }) => {
        onFileChange && onFileChange({ file: file, fileList: newFileList });
    };
    const handleRemove = (file) => {
        let currentFile;
        Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then((ret) => {
            // Prevent removing file
            if (ret === false) {
                return;
            }
            const removedFileList = removeFileItem(file, fileList);
            if (removedFileList) {
                currentFile = Object.assign(Object.assign({}, file), { status: 'removed' });
                fileList === null || fileList === void 0 ? void 0 : fileList.forEach((item) => {
                    const matchKey = currentFile.uid !== undefined ? 'uid' : 'name';
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) {
                        item.status = 'removed';
                    }
                });
                onFileChange && onFileChange({ file: currentFile, fileList: removedFileList });
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SortableList
        // 当移动 1 之后再触发排序事件，默认是0，会导致无法触发图片的预览和删除事件
        , { 
            // 当移动 1 之后再触发排序事件，默认是0，会导致无法触发图片的预览和删除事件
            distance: 1, axis: "xy", helperClass: "SortableHelper", 
            // @ts-ignore
            items: fileList, onSortEnd: onSortEnd, props: props, onChange: handleChange, onRemove: handleRemove, onPreview: onPreview })));
});
if (process.env.NODE_ENV !== 'production') {
    DragableList.displayName = 'DragableList';
}
export default DragableList;
